module.exports = __webpack_public_path__ + "static/media/4.c06c3146.JPG";